import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, MenuItem, FormControl, InputLabel, Select, FormHelperText, Checkbox, FormControlLabel, Grid, Typography } from '@mui/material';
import { useState } from 'react';

export const CreateQuizQuestionModal = ({ showAdd, setShowAdd, lngsltd, newQuestion, handleInputChangeQN, questionNumberError, handleInputChange,
    questionTextError, handleRemoveImage, setNewQuestion, option1Error, option2Error, option3Error,
    option4Error, correctOptionError, handleCheckboxChange, handleAdd }) => {

    // Add state for selected language


    return (
        <Dialog open={showAdd} onClose={() => setShowAdd(false)} fullWidth>
            <DialogTitle style={{ backgroundColor: '#efedf0' }}>
                {lngsltd["Add Question"]}
            </DialogTitle>
            <DialogContent>
                {/* Language Dropdown */}
                <FormControl fullWidth margin="normal">
                    <InputLabel>{lngsltd["Select Language"]}</InputLabel>
                    <Select
                        id="languageCode"
                        name="languageCode"
                        value={newQuestion.languageCode}
                        onChange={(e) => setNewQuestion({ ...newQuestion, languageCode: e.target.value })}
                        label={lngsltd["Select Language"]}
                    >
                        <MenuItem value="en-US">{lngsltd["English"]}</MenuItem>
                        <MenuItem value="nb-NO">{lngsltd["Norwegian"]}</MenuItem>
                    </Select>
                </FormControl>
                <TextField
                    label={lngsltd["Question Number"]}
                    fullWidth
                    margin="normal"
                    name="questionNo"
                    value={newQuestion.questionNo}
                    onChange={handleInputChangeQN}
                    error={Boolean(questionNumberError)}
                    helperText={questionNumberError}
                />
                <TextField
                    label={`${lngsltd["Question Text"]} *`}
                    fullWidth
                    margin="normal"
                    name="questionText"
                    value={newQuestion.questionText}
                    onChange={handleInputChange}
                    error={Boolean(questionTextError)}
                    helperText={questionTextError}
                />
                {newQuestion.imageFile && (
                    <Grid container spacing={2} alignItems="center" marginY={2}>
                        <Grid item>
                            <Typography>{lngsltd["Selected Image Preview"]}:</Typography>
                        </Grid>
                        <Grid item>
                            <img src={URL.createObjectURL(newQuestion.imageFile)} alt="Selected Image Preview" style={{ maxWidth: '100px', maxHeight: '100px' }} />
                        </Grid>
                        <Grid item>
                            <Button variant="contained" color="secondary" onClick={handleRemoveImage}>
                                {lngsltd["Remove Image"]}
                            </Button>
                        </Grid>
                    </Grid>
                )}

                <Typography variant="subtitle1" gutterBottom>{lngsltd["Image File"]} :</Typography>
                <Button
                    variant="outlined"
                    component="label"
                    fullWidth
                    margin="normal"
                >
                    Upload
                    <input
                        type="file"
                        hidden
                        name="imageFile"
                        onChange={(e) => setNewQuestion({ ...newQuestion, imageFile: e.target.files[0] })}
                    />
                </Button>

                <FormControl variant="outlined" fullWidth margin="normal" sx={{ mt: 3 }}>
                    <InputLabel>{"Question Type"}</InputLabel>
                    <Select
                        id="questionType"
                        name="questionType"
                        label={"Question Type"}
                        value={newQuestion.questionType}
                        onChange={(e) => setNewQuestion({ ...newQuestion, questionType: e.target.value })}
                    >
                        <MenuItem value="Single Choice">Single Choice</MenuItem>
                        <MenuItem value="Multiple Choice">Multiple Choice</MenuItem>
                        <MenuItem value="True/False">True/False</MenuItem>
                    </Select>
                </FormControl>

                <TextField
                    label={`${lngsltd["Option 1"]} *`}
                    fullWidth
                    margin="normal"
                    name="option1"
                    value={newQuestion.option1}
                    onChange={handleInputChange}
                    error={Boolean(option1Error)}
                    helperText={option1Error}
                />
                <TextField
                    label={`${lngsltd["Option 2"]} *`}
                    fullWidth
                    margin="normal"
                    name="option2"
                    value={newQuestion.option2}
                    onChange={handleInputChange}
                    error={Boolean(option2Error)}
                    helperText={option2Error}
                />
                {newQuestion.questionType !== "True/False" && (
                    <>
                        <TextField
                            label={`${lngsltd["Option 3"]} *`}
                            fullWidth
                            margin="normal"
                            name="option3"
                            value={newQuestion.option3}
                            onChange={handleInputChange}
                            error={Boolean(option3Error)}
                            helperText={option3Error}
                        />
                        <TextField
                            label={`${lngsltd["Option 4"]} *`}
                            fullWidth
                            margin="normal"
                            name="option4"
                            value={newQuestion.option4}
                            onChange={handleInputChange}
                            error={Boolean(option4Error)}
                            helperText={option4Error}
                        />
                    </>
                )}
                {(newQuestion.questionType === "Single Choice" || newQuestion.questionType === "True/False") && (
                    <FormControl fullWidth margin="normal">
                        <InputLabel id="correctOption-label">{lngsltd["Correct Option"]}</InputLabel>
                        <Select
                            labelId="correctOption-label"
                            id="correctOption"
                            name="correctOption"
                            value={newQuestion.correctOptions[0]}
                            onChange={handleInputChange}
                            error={Boolean(correctOptionError)}
                        >
                            <MenuItem value="" disabled>{lngsltd["Select Correct Option"]}</MenuItem>
                            <MenuItem value={newQuestion.option1}>{newQuestion.option1}</MenuItem>
                            <MenuItem value={newQuestion.option2}>{newQuestion.option2}</MenuItem>
                            {newQuestion.questionType === "Single Choice" && (
                                <>
                                    <MenuItem value={newQuestion.option3}>{newQuestion.option3}</MenuItem>
                                    <MenuItem value={newQuestion.option4}>{newQuestion.option4}</MenuItem>
                                </>
                            )}
                        </Select>
                        {correctOptionError && <FormHelperText error>{correctOptionError}</FormHelperText>}
                    </FormControl>
                )}
                {newQuestion.questionType === "Multiple Choice" && (
                    <div>
                        <Typography>{"Correct Options"}</Typography>
                        {[newQuestion.option1, newQuestion.option2, newQuestion.option3, newQuestion.option4].map((option, index) => (
                            <FormControlLabel
                                key={index}
                                control={
                                    <Checkbox
                                        checked={newQuestion.correctOptions.includes(option)}
                                        onChange={(e) => handleCheckboxChange(option, e.target.checked)}
                                        color="primary"
                                    />
                                }
                                label={option}
                            />
                        ))}
                    </div>
                )}
            </DialogContent>
            <DialogActions>
                <Button variant="contained" color="primary" onClick={handleAdd}>
                    {lngsltd["Add"]}
                </Button>
                <Button variant="outlined" onClick={() => setShowAdd(false)}>
                    {lngsltd["Cancel"]}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

